<template>
	<div class="product-rating">
		<div class="product-rating__mask">
			<SVGStarFilled
				class="product-rating__mask-icon"
				v-for="i in max"
				:key="`rating-mask-${i}`"
			/>
		</div>
		<div class="product-rating__value">
			<SVGStarFilled
				class="product-rating__value-icon"
				v-for="i in fullStars"
				:key="`rating-value-${i}`"
			/>
			<SVGStarFilledHalf
				class="product-rating__value-icon"
				v-if="halfStar"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		rating: {
			default: 0,
		},
		max: {
			default: 5,
		}
	},
	computed: {
		fullStars() {
			return Math.floor(this.rating);
		},
		halfStar() {
			return this.rating - this.fullStars >= 0.5;
		}
	}
}
</script>

<style>
</style>